import { forwardRef, LegacyRef } from 'react';
import ManagementDecorator from '../ManagementDecorator';

function ManagementHome(
  _: object,
  ref: LegacyRef<HTMLDivElement>
): JSX.Element {
  return ManagementDecorator(ref, () => (
    <div
      className="construction-site"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        marginTop: '100px',
      }}
    >
      <span
        style={{ fontSize: '60px', marginBottom: '20px' }}
        role="img"
        aria-label="hammer-icone"
      >
        🔨
      </span>
      <h1 style={{ marginTop: '20px', color: '#343a40' }}>
        Accueil en Construction
      </h1>
    </div>
  ));
}

export default forwardRef(ManagementHome);
